import styled from 'styled-components';
import { LoaderButton } from '../../component/button/index';
import { colors } from '../../component/colors';
import { Input, InputWithIcon } from '../../component/input';
import { Link } from 'react-router-dom';
import { pxToRem } from '../../utils/pxToRem';

export const AuthWrapper = styled.main`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  @media (max-width: 560px) {
    position: absolute;
  }
`;
export const AuthContainer = styled.section`
  display: flex;
  align-items: center;
  height: 100vh;

  @media (max-width: 560px) {
    display: block;
  }
`;
export const FormSection = styled.section`
  flex: 1;
  background-color: ${colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  @media (max-width: 560px) {
    padding: 30px 0;
  }
`;
export const FormWrapper = styled.div`
  width: 80%;
  max-width: 520px;
`;
export const FormHeader = styled.h3`
  font-weight: 500;
  font-size: ${pxToRem(25)};
  margin-top: 30px auto;
`;
export const FormBox = styled.form`
  margin-top: 30px;
`;
export const LogoContainer = styled.div`
  width: 70px;
  margin: auto;
  height: 56px;
  text-align: center;
`;
export const Logo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const LoginInput = styled(Input)`
  margin-bottom: 10px;
`;
export const LoginInputWithIcon = styled(InputWithIcon)`
  margin-bottom: 20px;
`;

export const ResetPasswordContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: ${pxToRem(14)};
  color: ${colors.textDark};
  margin: 15px 0 25px 0;
`;
export const RememberMeInput = styled.input`
  margin-right: 7px;
`;
export const RememberMeContainer = styled.div``;
export const CheckboxLabel = styled.label``;
export const ResetPasswordLink = styled(Link)`
  font-size: ${pxToRem(14)};
  color: ${colors.textDark};
  text-decoration: none;
`;

export const LoginButton = styled(LoaderButton)`
  width: 100%;
  margin-top: 15px;
`;
export const ImageContainer = styled.div`
  background-color: #fafafa;
  flex: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  height: 100vh;

  @media (max-width: 922px) {
    flex: 1.5;
  }
  @media (max-width: 768px) {
    flex: 0.8;
  }
  @media (max-width: 560px) {
    display: none;
  }
`;

export const SideImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
